const initialState = () => ({
  menus: [],
});

const state = initialState();

export default state;
